import { cropName } from 'helpers/cropName'
import { FC } from 'react'
import {
  Avatar as AvatarUI,
  AvatarFallback,
  AvatarImage,
  cn,
} from '@wellesley/ui'
import { LucideIcon } from 'lucide-react'

export type AvatarProps = {
  name?: string
  Icon?: string | null | LucideIcon
  className?: string
  isActive?: boolean
}

export const Avatar: FC<AvatarProps> = ({
  name,
  Icon,
  className,
  isActive,
}) => {
  return (
    <AvatarUI
      className={cn(
        'flex h-12 w-12 items-center justify-center rounded-m bg-slate-200 2xl:h-14 2xl:w-14',
        {
          'bg-blue_100 text-white': isActive,
        },
        className,
      )}
    >
      {typeof Icon === 'string' || !Icon ? (
        <>
          {Icon && <AvatarImage src={Icon} alt="app-avatar" />}
          <AvatarFallback
            className={cn('bg-slate-200', {
              'bg-blue_100 text-white': isActive,
            })}
          >
            {name ? cropName(name) : ''}
          </AvatarFallback>
        </>
      ) : (
        <div className="flex h-full w-full items-center justify-center ">
          <Icon size={24} />
        </div>
      )}
    </AvatarUI>
  )
}
